import { PageHeader } from "antd";
import React, { Component } from "react";
import { connect } from "react-redux";
import TabbedDynamicTable from "../../../Components/TabbedDynamicTable";
import EscuelasTab from "./EscuelasTab/EscuelasTab";
import GruposTab from "./GruposTab/GruposTab";
import ListasTab from "./ListasTab/ListasTab";
import AlumnosTab from "./AlumnosTab/AlumnosTab";

class Escuela extends Component {
  render() {
    const tabs = [
      {
        key: "escuelas",
        label: "Escuela",
        customContent: <EscuelasTab history={this.props.history} />,
        forceRender: true,
      },
      {
        key: "grupos",
        label: "Grupos",
        customContent: <GruposTab history={this.props.history} />,
        forceRender: true,
      },
      {
        key: "listas",
        label: "Listas",
        customContent: <ListasTab history={this.props.history} />,
        forceRender: true,
      },
      {
        key: "alumnos",
        label: "Alumnos",
        customContent: <AlumnosTab history={this.props.history} />,
        forceRender: true,
      },
    ];

    return (
      <>
        <PageHeader
          title="Escuela"
          style={{
            border: "1px solid rgb(235, 237, 240)",
            backgroundColor: "white",
            marginBottom: 0,
          }}
        />
        <div style={{ backgroundColor: "white", padding: "8px 8px 9px 8px", marginTop: 8, borderRadius: 10 }}>
          <TabbedDynamicTable tabs={tabs} defaultActiveKey="escuelas" />
        </div>
      </>
    );
  }
}

const mapStateToProps = (state) => ({
  empresaId: state.empresa.id,
});

export default connect(mapStateToProps)(Escuela);
